// extracted by mini-css-extract-plugin
export var alternate = "_m-j";
export var black = "_m-6";
export var blue = "_m-f";
export var blueLight = "_m-e";
export var brand = "_m-8";
export var darkMode = "_m-b";
export var error = "_m-a";
export var gray = "_m-5";
export var grayBlue = "_m-d";
export var iconWrapper = "_m-3";
export var inactive = "_m-7";
export var indigo = "_m-g";
export var orange = "_m-i";
export var pink = "_m-h";
export var primary = "_m-0";
export var purple = "_m-9";
export var success = "_m-4";
export var warning = "_m-c";
export var white = "_m-1";
export var whiteSuccess = "_m-2";